<template>
  <v-container fluid>
    <div class="receipt">
      <div class="paper">
        <dl>
          <dt>Fecha de corte: </dt>
          <dd>{{ objetoCDCaja.fechaYHoraDelCorte }}</dd>
        </dl>
        <div style="text-align:center;">
          <span><<<<<<< CORTE DE CAJA >>>>>>>>></span><br />
          Usuario que hizo el corte: {{ objetoCDCaja.usuarioCorte }}
        </div>
        <dl class="total">
          <dt>Entrada efectivo:</dt>
          <dd>{{ formateaMoneda(objetoCDCaja.entradaDeDinero) }}</dd>
        </dl>
        <dl class="total">
          <dt>Salida efectivo:</dt>
          <dd>{{ formateaMoneda(objetoCDCaja.salidaDeDinero) }}</dd>
        </dl>
        <dl class="total">
          <dt>Dinero en caja despues del corte:</dt>
          <dd>{{ formateaMoneda(objetoCDCaja.dineroActualEnCaja) }}</dd>
        </dl>
        <br />

        <dl>
          <dt>
            Firma encargado de cobranza:
          </dt>
        </dl>
        ______________________________________
        <hr />
      </div>
    </div>
  </v-container>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { FormatoMoneda, FormatoGuia } from "@/Utils/Utils";
export default {
  async beforeMount() {
    await this.getSucursalEnLaQueEstoy(this.logedInUserInfo.sucursal);
  },
  computed: {
    ...mapState("sesion", {
      sucursalInfo: state => state.sucursalData,
      logedInUserInfo: state => state.logedInUserInfo
    }),
    ...mapState("abonosEnvios", {
      objetoDatosAbonoSencillo: state => state.objetoDatosAbonoSencillo,
      objetoDatosMultiple: state => state.objetoDatosMultiple,
      objetoDatosCambioDireccion: state => state.objetoDatosCambioDireccion,
      nombreAbonante: state => state.nombreAbonante,
      objetoCDCaja: state => state.objetoDatosImprimirTicketCorteDeCaja
    })
  },
  methods: {
    ...mapActions("sesion", ["getSucursalEnLaQueEstoy"]),
    formateaMoneda(moneda) {
      return FormatoMoneda.format(moneda);
    }
  }
};
</script>
<style lang="css" scoped>
* {
  font-size: 18px/1.5;
   font-family: 'Lato', sans-serif;
  box-sizing: border-box;
  align-items: left;
  letter-spacing: -1px;
  line-height: 0.9;
}
body {
  display: flex;
  height: 100vh;
  margin: 0;
  justify-content: center;
  align-items: left;
  font-size: 12px;
}
.receipt {
  align-items: left;
  word-break: break-word;
  width: 302px;
  border: 1px dotted black;
  border-width: 1px 0;
}
.receipt .paper {
  background: white;
  text-align: left;
}
.receipt h1 {
  font-size: 150%;
  margin: 0;
}
.receipt h1,
.receipt .event {
  text-align: center;
  line-height: 1;
}
.receipt dl {
  display: flex;
  flex-wrap: wrap;
  margin: 1.5em 0 0;
}
.receipt dt,
.receipt dd {
  margin: 0;
  width: 50%;
}
.receipt dd {
  text-align: right;
}
.receipt .total {
  margin: 0;
}
.receipt .total:before {
  display: block;
  width: 100%;
  text-align: right;
}
.receipt .total dt {
  text-align: right;
}
.receipt .total dd {
  padding-left: 0.5em;
  text-align: left;
}
</style>
